import React, { PropsWithChildren } from 'react';

type Props = {
  title: string;
  className?: string;
  SubInformation?: () => React.ReactElement;
};

export const InputRow = ({
  title,
  children,
  className,
  SubInformation,
}: PropsWithChildren<Props>): React.ReactElement => {
  return (
    <>
      <div className={`${className ?? ''}`}>
        <div className={`mb-2 flex flex-row items-center`}>
          <div className={`font-bold text-xs mr-auto text-bluegray-450`}>
            {title}
          </div>
          {SubInformation && <SubInformation />}
        </div>
        <div className={``}>{children}</div>
      </div>
    </>
  );
};
